import { Root } from '@radix-ui/react-visually-hidden';
import type { ComponentPropsWithRef } from 'react';

export type VisuallyHiddenProps = ComponentPropsWithRef<typeof Root>;

/**
 * Content available to assistive technology but not painted.
 *
 * Not `display: none` and not `hidden` — both remove the node from the
 * accessibility tree, which is the opposite of the intent. Used for the text
 * that gives an icon-only control its name and for live-region announcements.
 */
export function VisuallyHidden(props: VisuallyHiddenProps) {
  return <Root {...props} />;
}
